export default __webpack_public_path__ + "static/media/(5).518c3f68.jpg";